module.exports = __webpack_public_path__ + "img/2023big11.56c1a708.png";